import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { RestaurantInfoService } from './restaurant-info.service';
import { IBasicInfo } from 'src/app/appModels/IBasicInfo';
import { environment } from 'src/environments/environment';
import { ThemeService } from '../theme.service';
@Injectable({
    providedIn: 'root'
})
export class RestaurantInfoResolver {
    S3_URL = environment.S3_URL;
    restaurantBasicInfo = new BehaviorSubject<IBasicInfo | null>(null);


    constructor(
        private restaurantInfoService: RestaurantInfoService,
        private _themeService: ThemeService
    ) {
        this.getBasicInfo();
    }

    /**
     * get basic info
     */
    public getBasicInfo(forceGet?: boolean) {
        if (!localStorage.getItem('tenant')) {
            return;
        }
        const basicInfoString = localStorage.getItem("basic-info");
        const basicInfo = basicInfoString ? JSON.parse(basicInfoString) : null;
        //  console.log('Basic Info from localStorage:', basicInfo);

        // Force fetch if requested
        if (forceGet) {
            this.getBasicInfoFromAPI().subscribe(res => {
                this.setBasicInfo(res);
            });
        }
        // Fetch from API if basicInfo is missing businessType or incomplete
        else if (!basicInfo || !basicInfo.businessType) {
            console.warn('Basic info is missing businessType or is incomplete, fetching from API');
            this.getBasicInfoFromAPI().subscribe(res => {
                this.setBasicInfo(res);
            });
        } else {
            this.restaurantBasicInfo.next(basicInfo);
        }
    }




    /**
     * get basic info from api
     * @returns
     */
    public getBasicInfoFromAPI(): Observable<IBasicInfo> {
        return this.restaurantInfoService.getBasicInfo();
    }

    public setBasicInfo(basicInfo: IBasicInfo) {
        localStorage.setItem("basic-info", JSON.stringify(basicInfo));
        this.restaurantBasicInfo.next(basicInfo);
    }


    /**
   * Getter for Restaurant image
   */
    get RestroImage() {
        const basicInfo = this.restaurantBasicInfo.value;
        if (!basicInfo) {
            return null;
        }

        const bucketPath = this.S3_URL + basicInfo.bucketName + '/';
        const isDarkMode = this._themeService.isDarkMode;

        const imageToUse = isDarkMode
            ? basicInfo.imageLink
            : basicInfo.darkLogo;

        if (imageToUse) {
            return bucketPath + imageToUse;
        }

        return '/assets/images/default-restro-img.svg';
    }

    /**
     * clear basic info
     */
    public clearBasicInfo() {
        this.restaurantBasicInfo.next(null);
        localStorage.removeItem('basic-info');
    }

}
